import { useQuery } from '@tanstack/react-query'
import { listPersonalAccessTokens } from '@/lib/api/features/personal-access-tokens'

export const PERSONAL_ACCESS_TOKENS_QUERY_KEY = ['personal-access-tokens'] as const

export function usePersonalAccessTokens() {
  return useQuery({
    queryKey: PERSONAL_ACCESS_TOKENS_QUERY_KEY,
    queryFn: listPersonalAccessTokens,
  })
}
